var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _path, _path2, _path3, _circle, _circle2, _path4, _circle3, _path5, _circle4, _path6, _circle5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcon3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 403.6,
    height: 502.7,
    viewBox: "0 0 403.6 502.7",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    fill: "#000000",
    overflow: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    x1: 201.937,
    y1: 452.037,
    x2: 201.937,
    y2: 309.689,
    gradientUnits: "userSpaceOnUse",
    id: "a"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.006,
    stopColor: "#F54EA2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1DDFDA"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    x1: 201.783,
    y1: 382.608,
    x2: 201.783,
    y2: 197.831,
    gradientUnits: "userSpaceOnUse",
    id: "b"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.006,
    stopColor: "#F54EA2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1DDFDA"
  }))), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    x1: 201.783,
    y1: 502.721,
    x2: 201.783,
    y2: 136.657,
    gradientUnits: "userSpaceOnUse",
    id: "c"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.006,
    stopColor: "#F54EA2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1DDFDA"
  }))), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    x1: 201.741,
    y1: 169.765,
    x2: 201.741,
    y2: 63.916,
    gradientUnits: "userSpaceOnUse",
    id: "d",
    gradientTransform: "matrix(1,0.00354,0.00354,-1,-0.28,169.051)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.006,
    stopColor: "#F54EA2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1DDFDA"
  }))), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    x1: 201.741,
    y1: 169.765,
    x2: 201.741,
    y2: 63.916,
    gradientUnits: "userSpaceOnUse",
    id: "e",
    gradientTransform: "matrix(-0.999994,0.00354301,-0.00354301,-0.999994,403.847,169.051)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.006,
    stopColor: "#F54EA2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1DDFDA"
  }))), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    x1: 239.808,
    y1: 181.514,
    x2: 239.808,
    y2: 75.664,
    gradientUnits: "userSpaceOnUse",
    id: "f",
    gradientTransform: "matrix(0.828051,0.560653,0.560653,-0.828051,79.9716,70.347)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.006,
    stopColor: "#F54EA2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1DDFDA"
  }))), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    x1: 239.808,
    y1: 181.514,
    x2: 239.808,
    y2: 75.664,
    gradientUnits: "userSpaceOnUse",
    id: "g",
    gradientTransform: "matrix(-0.828051,0.560653,-0.560653,-0.828051,323.595,70.3471)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.006,
    stopColor: "#F54EA2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1DDFDA"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: " M 201.723 95.511 L 201.542 146.656",
    stroke: "#1DDFDA",
    strokeWidth: 20,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: " M 79.7432 441.729 L 201.783 319.689 L 324.132 442.037",
    stroke: "url(#a)",
    strokeWidth: 20,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    fill: "none"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: " M 37.0061 372.608 L 201.783 207.831 L 366.561 372.608",
    stroke: "url(#b)",
    strokeWidth: 20,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    fill: "none"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 201.783,
    cy: 319.689,
    r: 173.032,
    stroke: "url(#c)",
    strokeWidth: 20,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    fill: "none"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 201.873,
    cy: 52.925,
    r: 42.925,
    stroke: "url(#d)",
    strokeWidth: 20,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    fill: "none"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: " M 201.844 95.511 L 202.025 146.656",
    stroke: "#1DDFDA",
    strokeWidth: 20,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    fill: "none"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 201.694,
    cy: 52.925,
    r: 42.925,
    stroke: "url(#e)",
    strokeWidth: 20,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    fill: "none"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: " M 326.761 133.581 L 298.087 175.932",
    stroke: "#1DDFDA",
    strokeWidth: 20,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    fill: "none"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 350.638,
    cy: 98.317,
    r: 42.925,
    stroke: "url(#f)",
    strokeWidth: 20,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    fill: "none"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: " M 76.805 133.581 L 105.48 175.932",
    stroke: "#1DDFDA",
    strokeWidth: 20,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    fill: "none"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 52.929,
    cy: 98.317,
    r: 42.925,
    stroke: "url(#g)",
    strokeWidth: 20,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    fill: "none"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon3);
export default __webpack_public_path__ + "static/media/icon3.581d3655dc61685a5a44d0bb1d9114fe.svg";
export { ForwardRef as ReactComponent };